// extracted by mini-css-extract-plugin
module.exports = {"root":"SalesGoals_root__N5-1D"};